import { useContext, useEffect } from 'react';
import { StoreContext } from '../StoreProvider';
import videojs from 'video.js';

const Subtitles = () => {
    const { customerData, player } = useContext(StoreContext);

    useEffect(() => {
        if (!player) {
            return;
        }
        addSubtitleButton();
    }, [player]);


    const onSubtitleButton = () => {
        if (!player || !player.el_) {
            return;
        }

        player.el_.parentNode.classList.toggle('player--hide-subtitles')
    }

    const addSubtitleButton = () => {
        if (!customerData?.theVideoGramStore?.player?.showSubtitle) {
            return;
        }
        if (!player || !player.controlBar) {
            return;
        }

        const videoJsButtonClass = videojs.getComponent('Button');
        const concreteButtonClass = videojs.extend(videoJsButtonClass, {
            constructor: function () {
                videoJsButtonClass.call(this, player);
            },
            handleClick: function () {
                onSubtitleButton();
            }
        });

        const subtitleButton = player.controlBar.addChild(new concreteButtonClass());
        subtitleButton.addClass('vjs-subtitles');
    }

    return null;
}

export default Subtitles;
